"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SessionActions_1 = __importDefault(require("./resources/session/actions/SessionActions"));
const RoomActions_1 = __importDefault(require("./resources/room/actions/RoomActions"));
const OrgActions_1 = __importDefault(require("./resources/org/actions/OrgActions"));
const OrgUnitActions_1 = __importDefault(require("./resources/orgUnit/actions/OrgUnitActions"));
const ArchiveActions_1 = __importDefault(require("./resources/archive/actions/ArchiveActions"));
const AuthActions_1 = __importDefault(require("./resources/auth/actions/AuthActions"));
const UserActions_1 = __importDefault(require("./resources/user/actions/UserActions"));
const PrescriptionAction_1 = __importDefault(require("./resources/prescription/actions/PrescriptionAction"));
const VidaasAction_1 = __importDefault(require("./resources/prescription/actions/VidaasAction"));
const RecordingActions_1 = __importDefault(require("./resources/recording/actions/RecordingActions"));
const SkinActions_1 = __importDefault(require("./resources/skin/actions/SkinActions"));
const ProfileActions_1 = __importDefault(require("./resources/profile/actions/ProfileActions"));
const InvoiceActions_1 = __importDefault(require("./resources/invoice/actions/InvoiceActions"));
const DashboardActions_1 = __importDefault(require("./resources/dashboard/actions/DashboardActions"));
const RegistryActions_1 = __importDefault(require("./resources/registry/actions/RegistryActions"));
const TranscriptionActions_1 = __importDefault(require("./resources/transcription/actions/TranscriptionActions"));
const default_1 = __importDefault(require("./config/default"));
class WiseApi {
    setup(options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.baseUrl = options && options.baseUrl ? options.baseUrl : default_1.default.App.baseUrl;
            if (options && options.token)
                this.token = options.token;
            else if (options && options.type === 'SYSTEMCLIENT' && options.login && options.password)
                yield this.loginBySystemClient(options.login, options.password);
            else if (options && options.type === 'USER' && options.login && options.password)
                yield this.loginByUser(options.login, options.password);
            else if (options && options.type === 'ORG' && options.login && options.password)
                yield this.loginByOrg(options.login, options.password);
            this.org = new OrgActions_1.default(this.token, this.baseUrl);
            this.orgUnit = new OrgUnitActions_1.default(this.token, this.baseUrl);
            this.session = new SessionActions_1.default(this.token, this.baseUrl, options.domain);
            this.room = new RoomActions_1.default(this.token, this.baseUrl);
            this.archive = new ArchiveActions_1.default(this.token, this.baseUrl);
            this.user = new UserActions_1.default(this.token, this.baseUrl);
            this.prescription = new PrescriptionAction_1.default(this.token, this.baseUrl);
            this.recording = new RecordingActions_1.default(this.token, this.baseUrl);
            this.profile = new ProfileActions_1.default(this.token, this.baseUrl);
            this.skin = new SkinActions_1.default(this.token, this.baseUrl);
            this.invoice = new InvoiceActions_1.default(this.token, this.baseUrl);
            this.dashboard = new DashboardActions_1.default(this.token, this.baseUrl);
            this.registry = new RegistryActions_1.default(this.token, this.baseUrl);
            this.vidaas = new VidaasAction_1.default(this.token, this.baseUrl);
            this.transcription = new TranscriptionActions_1.default(this.token, this.baseUrl);
        });
    }
    loginByOrg(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = new AuthActions_1.default(this.baseUrl);
            const response = yield auth.loginByOrg({ login, password });
            this.token = response.access.token;
        });
    }
    loginByUser(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = new AuthActions_1.default(this.baseUrl);
            const response = yield auth.loginByUser({ login, password });
            this.token = response.access.token;
        });
    }
    loginBySystemClient(login, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const auth = new AuthActions_1.default(this.baseUrl);
            const response = yield auth.loginBySystemClient({ login, password });
            this.token = response.access.token;
        });
    }
}
const initializer = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const wiseapi = new WiseApi();
    yield wiseapi.setup(options);
    return wiseapi;
});
module.exports = initializer;
exports.default = initializer;
